import { AnalyticsController } from 'analytics/analytics-controller';
import * as GoogleTagManager from 'analytics/providers/google-tag-manager';
import * as DevelopmentAnalytics from 'analytics/providers/development-reporter';
import { 
  GTM_SMARTCHAT_BETA_PAGE_VIEW,
  GTM_SMARTCHAT_BETA_OPT_IN,
  GTM_SMARTCHAT_BETA_OPT_OUT,
  GTM_SMARTCHAT_BETA_NEW_USER_MESSAGE,
  GTM_SMARTCHAT_BETA_FILTER_APPLIED,
  GTM_SMARTCHAT_BETA_ERROR,
  GTM_SMARTCHAT_BETA_SESSION_END,
} from 'constants/events';

/**
 * Tracks when a user views the AI Search View on the Search Page
 */
export const trackSmartchatPageView = () => AnalyticsController.trackEvent(GTM_SMARTCHAT_BETA_PAGE_VIEW);

/**
 * Tracks when a user opts into SmartChat Beta
 */
export const trackSmartchatOptIn = () => AnalyticsController.trackEvent(GTM_SMARTCHAT_BETA_OPT_IN);

/**
 * Tracks when a user opts out of SmartChat Beta
 */
export const trackSmartchatOptOut = () => AnalyticsController.trackEvent(GTM_SMARTCHAT_BETA_OPT_OUT);

/**
 * Tracks when a user sends a new message in SmartChat
 */
export const trackSmartchatNewUserMessage = () => AnalyticsController.trackEvent(GTM_SMARTCHAT_BETA_NEW_USER_MESSAGE);

/**
 * Tracks when filters are applied via SmartChat
 */
export const trackSmartchatFilterApplied = () => AnalyticsController.trackEvent(GTM_SMARTCHAT_BETA_FILTER_APPLIED);

/**
 * Tracks when SmartChat encounters an error or shows fallback response
 */
export const trackSmartchatError = () => AnalyticsController.trackEvent(GTM_SMARTCHAT_BETA_ERROR);

/**
 * Event tracks when user leaves AI search. 
 * Records the session duration only.
 */
export const trackSmartchatSessionEnd = (durationSeconds: number) => {
  GoogleTagManager.trackSmartchatSessionEndEvent(
    GTM_SMARTCHAT_BETA_SESSION_END,
    durationSeconds
  );
  DevelopmentAnalytics.trackSmartchatSessionEndEvent(
    GTM_SMARTCHAT_BETA_SESSION_END,
    durationSeconds
  );
};
